import React from 'react';
import PropTypes from 'prop-types';
import { NeoCard, NeoTable } from '../../../../components/Common';

const ProfileTabList = ({
    title,
    description,
    icon,
    actionButton,
    columns,
    data = [],
    isLoading = false,
    emptyMessage = "Nenhum registro encontrado",
    emptySubMessage,
    keyField = "id",
}) => {
    return (
        <NeoCard
            title={title}
            subtitle={description}
            headerIcon={icon}
            headerActions={actionButton}
            thinBorder={true}
            bodyClassName="p-0"
            className="mt-4"
        >
            <NeoTable
                columns={columns}
                data={data}
                loading={isLoading}
                emptyMessage={emptyMessage}
                emptySubMessage={emptySubMessage}
                keyField={keyField}
                defaultItemsPerPage={10}
                itemsPerPageOptions={[10, 20, 50]}
            />
        </NeoCard>
    );
};

ProfileTabList.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    icon: PropTypes.string,
    actionButton: PropTypes.node,
    columns: PropTypes.array.isRequired,
    data: PropTypes.array,
    isLoading: PropTypes.bool,
    emptyMessage: PropTypes.string,
    emptySubMessage: PropTypes.string,
    keyField: PropTypes.string,
};

export default ProfileTabList;
